import { API_ORIGIN, VITE_ENV_NAME } from '@/shared/lib/env';

export const isProd = () => {
  return VITE_ENV_NAME === 'prod';
};

// デバッグメニュー・feature flag override 等を有効にするか。
// dev 環境 or ローカル開発（localhost）でのみ有効。
// 'unknown'（VITE_ENV_NAME 未設定）だけでは有効にしない（fail-closed）。
export const isDebugEnabled = () => {
  return VITE_ENV_NAME === 'dev' || isOnlyLocalhost();
};

export const isOnlyLocalhost = () => {
  return location.hostname === 'localhost' && API_ORIGIN.includes('localhost');
};

export const isLgwanAccess = () => {
  return location.hostname.endsWith('bns.kpn1.asp.lgwan.jp');
};
